import { render, staticRenderFns } from "./InfoDocumentsItem.vue?vue&type=template&id=3f8f8934&scoped=true&"
import script from "./InfoDocumentsItem.vue?vue&type=script&lang=js&"
export * from "./InfoDocumentsItem.vue?vue&type=script&lang=js&"
import style0 from "./InfoDocumentsItem.vue?vue&type=style&index=0&id=3f8f8934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f8934",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiDocumentIcon: require('/app/components/ui/DocumentIcon.vue').default})
